<!--
 * @Author: Jarun
 * @Date: 2021-03-25 16:06:51
 * @LastEditTime: 2021-04-16 10:35:18
 * @LastEditors: Please set LastEditors
 * @Description: LoginLogo
 * @FilePath: \box.mengw.com\src\components\LoginLogo\LoginLogo.vue
-->
<template>
    <div class="login_logo" :style="{ backgroundImage: `url(${iconLogo})` }"></div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, } from 'vue';
import './LoginLogo.less';
import iconLogo from '@/assets/images/common/logo2.png';

import Util from "@/assets/js/lib/util";

export default defineComponent({
  name: 'LoginLogo',
  components: {
  },
  props: {
  },
  setup() {

    const state = reactive({
        util: new Util(),
        iconLogo,
    })
    return {
      ...toRefs(state)
    };
  },
});
</script>
